import { Component } from '@angular/core';
import { AppModule } from '../app.module';
import { ReportService } from '../shared/report.service';
import { ActivatedRoute } from '@angular/router';
import { Base64Report } from '../models/report';
import { NotificationService } from '../shared/notification.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PdfViewer } from "../shared/pdf-viewer/pdf-viewer";
import { Document } from '../models/incident';

@Component({
  selector: 'app-invoice',
  imports: [AppModule, PdfViewer],
  templateUrl: './invoice.html',
  styleUrl: './invoice.less'
})
export class Invoice {

  invoice : Base64Report | null = null;
  safePdfUrl: SafeResourceUrl | null = null;

  constructor(
    private reportService: ReportService,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      const quoteId = +params['quoteId'];
      this.reportService.getInvoicePDFWithQuoteId(quoteId).subscribe({
        next: (response : Document) => {
          this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.url);
        },
        error: (err) => {
          this.notificationService.handleError(err, 'Failed to load invoice PDF.');
        }
      });
    });
  }

  public goBackToQuote() {
    window.history.back();
  }
}
